export interface LegendItem {
  key: string
  label: string
  color: string
}

export interface ChartLegendProps {
  items: LegendItem[]
  visibleItems: Record<string, boolean>
  onToggle: (key: string) => void
}

export function ChartLegend({ items, visibleItems, onToggle }: ChartLegendProps) {
  return (
    <div className="flex flex-wrap gap-4 mt-3 text-xs">
      {items.map((item) => (
        <div
          key={item.key}
          className="flex items-center gap-2 cursor-pointer hover:opacity-75 transition-opacity"
          onClick={() => onToggle(item.key)}
        >
          <div
            className="w-3 h-3 rounded-full"
            style={{
              backgroundColor: item.color,
              opacity: visibleItems[item.key] ? 1 : 0.3
            }}
          />
          <span style={{ opacity: visibleItems[item.key] ? 1 : 0.5 }}>{item.label}</span>
        </div>
      ))}
    </div>
  )
}
